export * from './dynamic-page/general-dynamic-page.component'
export * from './messages'
